'use client';

import React from 'react';
import Link from 'next/link';

export default function NotFound() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4"
      style={{ background: '#F5F5F5' }}
    >
      <div className="flex flex-col sm:flex-row items-center gap-10 sm:gap-14 text-center sm:text-left">
        <div>
          <div
            className="font-black"
            style={{ fontSize: 'clamp(64px, 10vw, 96px)', color: '#0D0D0D', letterSpacing: '-0.05em', lineHeight: 1 }}
          >404</div>
          <div className="text-lg font-black mt-3" style={{ color: '#0D0D0D', letterSpacing: '-0.03em' }}>Page not found</div>
          <div className="text-sm mt-2 max-w-xs" style={{ color: 'rgba(13,13,13,0.44)', lineHeight: 1.7 }}>
            The requested resource could not be found
          </div>
        </div>
        <div
          className="font-black hidden sm:block"
          style={{ fontSize: 'clamp(28px, 4vw, 40px)', color: 'rgba(217,0,18,0.25)', letterSpacing: '-0.03em' }}
        >VS</div>
        <div className="text-center">
          <div style={{ lineHeight: 1 }}>
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'inline-block' }}>
              <ellipse cx="34" cy="32" rx="22" ry="26" fill="rgba(217,0,18,0.08)" stroke="rgba(217,0,18,0.25)" strokeWidth="2.5"/>
              <line x1="50" y1="52" x2="68" y2="70" stroke="rgba(217,0,18,0.25)" strokeWidth="5" strokeLinecap="round"/>
              <ellipse cx="34" cy="32" rx="10" ry="12" fill="none" stroke="rgba(217,0,18,0.18)" strokeWidth="1.5" strokeDasharray="3 3"/>
            </svg>
          </div>
          <div className="text-lg font-black mt-3" style={{ color: '#0D0D0D', letterSpacing: '-0.03em' }}>PaddleVS</div>
          <div className="text-sm mt-2 max-w-xs" style={{ color: 'rgba(13,13,13,0.44)', lineHeight: 1.7 }}>
            The ultimate pickleball paddle comparison platform
          </div>
        </div>
      </div>
      <Link
        href="/"
        className="mt-12 versusButton pill"
        style={{ fontSize: '11px' }}
      >
        Back to PaddleVS
      </Link>
    </div>
  );
}